<template>
    <main-content>
        <div class="bg-white shadow-sm rounded p-4">
            <settlement-form :form_data="form_data"
                             :password="password"
                             :form_meta_data="form_meta_data"
                             @settlement="settlement"
                             :on_submit="sendCode"
            >
            </settlement-form>
        </div>
    </main-content>
</template>

<script>
    import SettlementForm from './components/settlement-form'
    import mainContent from '@/components/main-content'
    import {i18n} from "@/plugins/i18n";
    import $ from "jquery";
    import Inputmask from "inputmask";
    import {walletService} from "@/common/api.service";

    export default {
        components: {
            SettlementForm,
            mainContent,
        },
        data() {
            return {
                password: {
                    value: '',
                },
                form_data: [
                    {
                        amount: '',
                        destination_number: '',
                        destination_firstname: '',
                        destination_lastname: '',
                    },
                ],
                form_meta_data: {
                    submit_btn_progress: false,
                    submit_btn_text: i18n.t('wallets.label.settlement'),
                },
            };
        },
        methods: {
            masked() {
                setTimeout(() => {
                    document.getElementById("google_authenticator_code") &&
                    Inputmask("9     9     9     9     9     9").mask(document.getElementById("google_authenticator_code"));
                }, 100);
            },
            sendCode() {

                if (!this.form_data.should_two_factor_settlement) {
                    this.settlement()
                    return;
                }

                let form = $('#submit_form');

                form.validate({
                    rules: {
                        password: {
                            required: true,
                        },
                    },
                });

                if (!form.valid()) {
                    window.scrollTo({top: 1, behavior: 'smooth'});
                    return;
                }

                this.form_meta_data.submit_btn_progress = true;
                this.form_data.otp = '';

                let params = {
                    wallet_id: this.$route.params.hashid,
                    password: this.password.value,
                    two_factor_type: this.form_data.two_factor_type,
                };

                walletService.sendVerificationCode(params).then(response => {
                    this.form_data.two_factor_type = response.data.data.two_factor_type;
                    this.masked();
                    $('#approve_modal').modal('show');

                    this.toastr.success(response.data.message);

                }).catch(({response}) => {
                    this.showMsg(form, 'danger', response.data.message);

                    if (response.data && response.data.data) {
                        form.validate().showErrors(response.data.data);
                    }

                    window.scrollTo({top: 1, behavior: 'smooth'});
                }).finally(() => {
                    this.form_meta_data.submit_btn_progress = false;
                });
            },
            settlement() {
                let form = $('#submit_form');
                console.log('ebi')

                form.validate({
                    rules: {
                        password: {
                            required: true,
                        },
                    },
                });

                if (! form.valid()) {
                    return;
                }

                this.form_meta_data.submit_btn_progress = true;

                let params = {
                    transfers: this.form_data,
                    password: this.password.value,
                    wallet_hashid: this.$route.params.hashid,
                    should_two_factor_settlement: this.form_data.should_two_factor_settlement,
                    otp: !this.form_data.otp ? '': this.toEng(this.form_data.otp),
                    two_factor_type: !this.form_data.two_factor_type ? '': this.form_data.two_factor_type,
                };

                walletService.settlementAyande(params, this.$route.params.hashid).then(response => {
                    $('#approve_modal').modal('hide');
                    this.$router.push('/wallets');
                }).catch(({response}) => {
                    this.showMsg(form, 'danger', response.data.message);
                    $('#approve_modal').modal('hide');


                    if (response.data && response.data.data) {
                        form.validate().showErrors(response.data.data);
                    }
                }).finally(() => {
                    this.form_meta_data.submit_btn_progress = false;
                });
            },
        },
    }
</script>
